export const TrackInsertMarkName = 'trackInsert';
export const TrackDeleteMarkName = 'trackDelete';
export const TrackFormatMarkName = 'trackFormat';
